import { TransactionMode } from 'app/types/listing';

interface ListingTransactionFields {
  transactionMode?: TransactionMode | null;
  price?: string | null;
  inventory?: string | null;
}

export function getListingTransactionFields(
  fields: ListingTransactionFields,
  transactionModeSupported: boolean,
): ListingTransactionFields {
  if (!transactionModeSupported) return {};

  return {
    transactionMode: fields.transactionMode,
    price: fields.transactionMode === TransactionMode.sell ? fields.price : null,
    inventory: fields.inventory,
  };
}
